export const InventorySearchEvents = {
  PRE_FETCH: 'pre_fetch_inventory_search',
  POST_FETCH: 'post_fetch_inventory_search',

  PRE_RENDER: 'pre_render_inventory_search_results',
  POST_RENDER: 'post_render_inventory_search_results',

  GARAGE_ITEM_ADD: 'garage_item_add',
  GARAGE_ITEM_ADDED: 'garage_item_added',
  GARAGE_ITEM_REMOVE: 'garage_item_remove',
  GARAGE_ITEM_REMOVED: 'garage_item_removed',
  GARAGE_CLEAR: 'garage_clear',
  GARAGE_CLEARED: 'garage_cleared',
  GARAGE_UPDATED: 'garage_updated',

  PRE_SEARCH_FILTER_UPDATE: 'inventory_search_filter_pre_update',
  POST_SEARCH_FILTER_UPDATE: 'inventory_search_filter_post_update',
};
